import * as React from 'react';
import { useTheme } from '../../../../theming/useTheme';
import { DividedCardComponent, DIVIDED_CARD_TYPES, CardComponentDataProps } from '../dividedCard/DividedCard';
import { BaseUnit } from '../../../../theming/baseUnitDefinition';

const numberOfLines = 3;
const componentConfigThemeKey = 'horizontalCard';

interface HorizontalCardThemeProps {
  cardBackgroundColor: string
  cardTextColorTypeNormal: string
  cardTextColorTypeHover: string
  cardTextColorTypeActive: string
  cardTextTypography: string
  baseUnit: BaseUnit
  borderRadius: number
  boxShadowTypeNormal: string
  boxShadowTypeActive: string
  boxShadowTypeHover: string
  borderWidthTypeNormal: number
  borderWidthTypeHover: number
  borderWidthTypeActive: number
  borderColorTypeNormal: string
  borderColorTypeHover: string
  borderColorTypeActive: string
}
type Props = CardComponentDataProps & HorizontalCardThemeProps;

const mapThemeProps = (theme: HorizontalCardThemeProps): HorizontalCardThemeProps => {
  return {
    cardBackgroundColor: theme.cardBackgroundColor,
    cardTextColorTypeNormal: theme.cardTextColorTypeNormal,
    cardTextColorTypeHover: theme.cardTextColorTypeHover,
    cardTextColorTypeActive: theme.cardTextColorTypeActive,
    cardTextTypography: theme.cardTextTypography,
    baseUnit: theme.baseUnit,
    borderRadius: theme.borderRadius,
    boxShadowTypeNormal: theme.boxShadowTypeNormal,
    boxShadowTypeActive: theme.boxShadowTypeActive,
    boxShadowTypeHover: theme.boxShadowTypeHover,
    borderWidthTypeNormal: theme.borderWidthTypeNormal,
    borderWidthTypeHover: theme.borderWidthTypeHover,
    borderWidthTypeActive: theme.borderWidthTypeActive,
    borderColorTypeNormal: theme.borderColorTypeNormal,
    borderColorTypeHover: theme.borderColorTypeHover,
    borderColorTypeActive: theme.borderColorTypeActive,
  };
};

export const HorizontalCardComponent = (props: Props) => (
  <DividedCardComponent
    {...props}
    dividedCardType={DIVIDED_CARD_TYPES.HORIZONTAL}
    numberOfLines={numberOfLines}
  />
);

export const HorizontalCard = (props: CardComponentDataProps) => {
  const themeContext = useTheme(mapThemeProps, componentConfigThemeKey);
  return <HorizontalCardComponent {...themeContext} {...props} />;
};
